import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { HELP_HOLIDAY_SETS } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import HolidaySet from "./HolidaySet";
import HolidaySetList from "./HolidaySetList";

export default function HolidaySets() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_HOLIDAY_SETS));
  }, [dispatch]);

  return <MasterDetail identifier="id" master={<HolidaySetList />} detail={<HolidaySet />} />;
}
